import "./constellation.css";
import React from "react";
import useConstellation from "../../../../../hooks/corral/constellation";
import { useCurrentUser } from "../../../../../hooks/currentUser";
import QuadrantBubble from "../QuadrantBubble";
import { Loader, Overlay, Container, Text, Center } from "@mantine/core";
import { useParams, useNavigate } from "react-router";

const Constellation = () => {
  const navigate = useNavigate();
  const { treeId, quadrantId } = useParams();
  const { currentUser } = useCurrentUser();
  const {
    skillDescriptions,
    constellation,
    constellationRef,
    dimensions,
    loading,
    saveGlyphSlot,
  } = useConstellation({
    currentUser,
    treeId,
    quadrantId,
  });
  if (loading) {
    return (
      <Overlay opacity={0.6} color="#000" zIndex={5}>
        <Loader size="xl" variant="bars" />
      </Overlay>
    );
  }

  const handleSave = (glyphId) => {
    saveGlyphSlot({ glyphId }).then(() =>
      navigate(`/campaigns/corral/arboretum/${treeId}`),
    );
  };

  return (
    <Container>
      <Center>
        <Text fw={700} size="lg">
          {constellation.name}
        </Text>
      </Center>
      <Center>
        {constellation && (
          <div className="constellation-card" ref={constellationRef}>
            {constellation.quadrants?.map((quadrant) => (
              <QuadrantBubble
                key={quadrant.id}
                dimensions={dimensions}
                graphObj={constellation}
                overrideCircleWidth={80}
                overrideCircleHeight={80}
                onClick={() => handleSave(quadrant.id)}
                skillDescription={skillDescriptions[quadrant.id]}
                variant={quadrantId}
                {...quadrant}
              />
            ))}
          </div>
        )}
      </Center>
    </Container>
  );
};

export default Constellation;
